import { render, staticRenderFns } from "./CTextNumber.vue?vue&type=template&id=5ae97d19"
import script from "./CTextNumber.vue?vue&type=script&lang=js"
export * from "./CTextNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ae97d19')) {
      api.createRecord('5ae97d19', component.options)
    } else {
      api.reload('5ae97d19', component.options)
    }
    module.hot.accept("./CTextNumber.vue?vue&type=template&id=5ae97d19", function () {
      api.rerender('5ae97d19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTextNumber.vue"
export default component.exports